import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  divider: { width: '100%', height: 1, backgroundColor: '#DEDEDE' },
});

export default styles;
